export default __webpack_public_path__ + "static/media/Hair_15_F_C2.8134e36a.svg";